import { render, staticRenderFns } from "./medicina-ocupacional-danger.vue?vue&type=template&id=6c299537&"
import script from "./medicina-ocupacional-danger.vue?vue&type=script&lang=js&"
export * from "./medicina-ocupacional-danger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports